
export function setTriageServiceRequest({ props: serviceRequest, state, actions }) {
  actions.setTriageRequest({
    serviceRequest
  })
}
